<template>
    <v-layout column>
        <v-flex>
            <div class="text-xs-left">
                <v-btn
                        flat
                        @click="goBack"
                >
                    <v-icon left small>fal fa-chevron-left</v-icon>
                    {{ $vuetify.t('$vuetify.back') }}
                </v-btn>
            </div>
        </v-flex>
        <v-flex v-if="purchase" xs12>
            <h2 class="primary--text">{{ purchase.document_identifier }}</h2>
            <v-list>
                <v-list-tile v-if="purchase.date">
                    <v-list-tile-avatar>
                        <v-icon color="primary">fal fa-calendar</v-icon>
                    </v-list-tile-avatar>
                    <v-list-tile-content>
                        <v-list-tile-title>{{ purchase.date }}</v-list-tile-title>
                    </v-list-tile-content>
                </v-list-tile>


                <v-list-tile v-if="purchase.store">
                    <v-list-tile-avatar>
                        <v-icon color="primary">fal fa-map-marker-alt</v-icon>
                    </v-list-tile-avatar>
                    <v-list-tile-content>
                        <v-list-tile-title>{{ purchase.store }}</v-list-tile-title>
                    </v-list-tile-content>
                </v-list-tile>
            </v-list>

            <v-spacer class="my-3"></v-spacer>

            <v-expansion-panel :value="itemsPanel">
                <v-expansion-panel-content :readonly="false" :hide-actions="false"
                                           style="background:transparent">
                    <template v-slot:header>
                        <h2 class="primary--text">{{ $vuetify.t('$vuetify.items') }}</h2>
                    </template>
                    <ItemsList
                            :items="purchase.details"
                            :displayEditQuantity=false
                            :displayRemove=false></ItemsList>

                </v-expansion-panel-content>
            </v-expansion-panel>

            <v-divider v-if="purchase.total" class="my-3 grey lighten-2"></v-divider>

            <v-flex offset-sm4 offset-md6 offset-lg8>
                <v-list-tile v-if="purchase.total">
                    <v-list-tile-content>
                        <v-list-tile-title><h2>{{ $vuetify.t('$vuetify.total') }}</h2></v-list-tile-title>
                    </v-list-tile-content>

                    <v-list-tile-action>
                        <h2>{{ purchase.total }}&nbsp;{{ purchase.currency }}</h2>
                    </v-list-tile-action>
                </v-list-tile>
            </v-flex>

            <v-spacer class="my-5"></v-spacer>
            <v-list>
                <v-list-tile v-if="purchase.loyalty_points > 0">
                    <v-list-tile-content>
                        <v-list-tile-title class="secondary--text headline"> {{ $vuetify.t('$vuetify.earned') }}
                        </v-list-tile-title>
                    </v-list-tile-content>

                    <v-list-tile-action class="secondary--text headline">
                        <span>{{purchase.loyalty_points}} {{ $vuetify.t('$vuetify.points') }}</span>
                    </v-list-tile-action>
                </v-list-tile>
            </v-list>

            <v-list three-line>
                <v-list-tile v-if="purchase.rescue_voucher">
                    <v-list-tile-content>
                        <v-list-tile-title class="secondary--text headline"> {{
                            $vuetify.t('$vuetify.vouchers.voucher_rescued') }}
                        </v-list-tile-title>
                        <v-list-tile-sub-title style="text-align: center;"> {{ purchase.rescue_voucher_name }}
                        </v-list-tile-sub-title>
                        <v-list-tile-sub-title style="text-align: center;"> {{ purchase.rescue_voucher }}
                        </v-list-tile-sub-title>
                    </v-list-tile-content>
                </v-list-tile>

                <v-list-tile v-if="purchase.emitted_voucher">
                    <v-list-tile-content>
                        <v-list-tile-title class="secondary--text headline"> {{
                            $vuetify.t('$vuetify.vouchers.voucher_emitted') }} {{
                            purchase.emitted_voucher}}
                        </v-list-tile-title>
                        <v-list-tile-sub-title style="text-align: center;"> {{
                            $vuetify.t('$vuetify.vouchers.voucher_due_date') }} {{
                            purchase.emitted_voucher_extra_info }}
                        </v-list-tile-sub-title>
                    </v-list-tile-content>
                </v-list-tile>

            </v-list>
        </v-flex>
        <v-btn
                fixed
                dark
                fab
                bottom
                right
                color="primary">
            <v-icon @click="addPurchaseItemsToCart()">fal fa-shopping-cart</v-icon>
        </v-btn>
    </v-layout>
</template>

<script>
    import {purchasesService} from '@/_services';
    import {getErrorMessage} from '@/_helpers';
    import ItemsList from '@/components/ItemsList.vue';

    export default {
        name: "PurchaseDetail",
        components: {ItemsList},
        data() {
            return {
                purchase: [],
                itemsPanel: 0,
            }
        },
        methods: {
            goBack() {
                this.$router.push({name: "purchases"});
            },
            addPurchaseItemsToCart() {
                var listItemsId = [];
                for (var i = 0; i < this.purchase.details.length; i++) {
                    if (Object.entries(this.purchase.details[i].menuItems).length === 0) {
                        listItemsId.push(this.purchase.details[i].item_id)
                    }
                }
                this.$store.dispatch("shop/addListOfItemsToCart", listItemsId);
            },
        },
        mounted() {
            let id = parseInt(this.$route.params.id);
            this.$store.dispatch("loader/setLoading", true);

            purchasesService.get(id).then(result => {
                    this.purchase = result;
                    this.$store.dispatch("loader/setLoading", false);

                },
                error => {
                    getErrorMessage(error, 'Getting the Transaction Detail', this);
                }
            );
        }
    }
</script>

<style scoped>

</style>
